import React from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Card, Heading } from '@tq/ui-components';

import { showInviteUserModalState } from 'store';
import { InviteUserForm, InviteUserModal } from '.';
import { ManageTeamInviteUserProps } from './fragments/ManageTeamInviteUserProps';

export const ManageTeamInviteUser: React.FC<ManageTeamInviteUserProps> = ({
  title = 'Invite user',
  buttonText = 'submit',
  teamOptions = [],
  disabled = false,
  pageType = 'ManageTeam',
}) => {
  const setShowInviteUserModal = useSetRecoilState(showInviteUserModalState);
  const showInviteUserModal = useRecoilValue(showInviteUserModalState);

  const onClose = () => setShowInviteUserModal(false);

  return (
    <>
      <Card my={8} p={6} data-testid='manage-team-invite-user-container'>
        {title && (
          <Heading fontSize='1.25rem' mb={4}>
            {title}
          </Heading>
        )}
        <InviteUserForm
          buttonText={buttonText}
          pageType={pageType}
          teamOptions={teamOptions}
          disabled={disabled}
        />
      </Card>
      {showInviteUserModal && <InviteUserModal onClose={onClose} />}
    </>
  );
};
